import window from 'window-or-global';
const plugin = {
	init(ed) {
		ed.on('beforeExecCommand', (e) => {
			/*
                The purpose of this plugin is to catch all indentation that uses padding-left and convert them to use margin-left
                this plugin does not apply the indentation, it just converts padding, onExecCommand will then apply indentation ontop of the
                normalised values.
            */
			if (e.command === 'Indent' || e.command === 'Outdent') {
				const editor = e.target;
				const node = editor.selection.getNode();
				const nodeName = node.nodeName.toLowerCase();

				if (nodeName !== 'li' && nodeName !== 'body') {
					const currentIndent =
						parseInt(editor.dom.getStyle(node, 'margin-left') || 0, 10) +
						parseInt(editor.dom.getStyle(node, 'padding-left') || 0, 10);
					if (currentIndent !== 0) {
						const indentAmount = editor.settings.indentation;
						const indentUnits = /[a-z%]+/i.exec(indentAmount);

						editor.dom.setStyle(node, 'padding-left', '');
						editor.dom.setStyle(node, 'margin-left', currentIndent + indentUnits);
					}
				}
			}
		});
	},

	getInfo() {
		return {
			longname: 'Confluence Indentation',
			author: 'Atlassian',
			authorurl: 'http://www.atlassian.com',
			version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
		};
	},
};

export default function () {
	window.tinymce.create('tinymce.plugins.ConfIndentation', plugin);
	window.tinymce.PluginManager.add('confindentation', window.tinymce.plugins.ConfIndentation);
}
